import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { BiometricsService } from '../services/biometrics.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../services/storage.service';
import { StorageEnum } from '../enums/storage.enum';
import { isPlatformBrowser } from '@angular/common';

/**
 * Guard that only allows access on mobile platforms (iOS/Android).
 * Redirects to previous page or login on web platform.
 */
@Injectable({
  providedIn: 'root',
})
export class MobileOnlyGuard implements CanActivate {
  private readonly isBrowser: boolean;

  constructor(
    private readonly router: Router,
    private readonly bioS: BiometricsService,
    private readonly storage: StorageService,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  canActivate(_route: unknown, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this.isBrowser) {
      return true; // Allow SSR to proceed
    }

    const platform = this.bioS.bioInfo.Platform.toLowerCase();

    // Only allow access on mobile platforms
    if (platform === 'ios' || platform === 'android') {
      return true;
    }

    // Redirect to appropriate page on web
    const redirectRoute = this.storage.getSession(StorageEnum.BioRedirectRoute);
    if (redirectRoute) {
      this.storage.removeSession(StorageEnum.BioRedirectRoute);
      return this.router.createUrlTree([redirectRoute]);
    }

    // Try to navigate back to previous page if user came from within the app
    const navigation = this.router.currentNavigation();
    const previousUrl = navigation?.previousNavigation?.finalUrl?.toString();

    if (previousUrl && previousUrl !== state.url) {
      return this.router.createUrlTree([previousUrl]);
    }

    // No in-app navigation history - redirect to login
    return this.router.createUrlTree(['/login']);
  }
}
